import React from "react";
import icon from "../../assets/Data.svg";

export default function DataVisualisationIcon({ size }) {
  return <img src={icon} width={size} />;
}
